import { AgentSkillType } from '../store/schemas'
import {
  Drafting,
  DraftDiscovery,
  LightbulbIntelligent,
  DraftCorrespondenceSend,
  Brainstorm,
  RespondToDiscovery,
  List,
  Document,
  QueryDocument,
} from '@/assets/icons'

// map each skill to its icon component
const skillIconMap: Partial<Record<AgentSkillType, React.FC<React.SVGProps<SVGSVGElement>>>> = {
  [AgentSkillType.BRAINSTORM]: Brainstorm,
  [AgentSkillType.DRAFT_CORRESPONDENCE]: DraftCorrespondenceSend,
  [AgentSkillType.DRAFT_DEMAND]: Drafting,
  [AgentSkillType.DISCOVERY_REQUEST]: DraftDiscovery,
  [AgentSkillType.RESPOND_TO_DISCOVERY]: RespondToDiscovery,
  [AgentSkillType.CREATE_OUTLINE]: List,
  [AgentSkillType.SUMMARIZE_BRIEF]: Document,
  [AgentSkillType.QUERY_DOCUMENT]: QueryDocument,
}

export default function SkillChipIcon({ skill }: { skill: AgentSkillType | string }) {
  const Icon = skillIconMap[skill as AgentSkillType] ?? LightbulbIntelligent

  return <Icon className="transition-all duration-300 text-brand-neutral-600 group-hover:text-brand-500" width={20} height={20} />
}
